import styled from "styled-components";

const SpinnerContainer = styled.div``;

export const Spinner = () => {
  return (
    <SpinnerContainer>
      <svg
        width="50px"
        height="50px"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <g transform="rotate(0 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.95s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(18 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.9s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(36 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.85s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(54 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.8s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(72 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.75s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(90 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.7s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(108 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.65s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(126 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.6s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(144 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.55s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(162 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.5s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(180 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.45s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(198 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.4s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(216 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.35s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(234 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.3s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(252 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.25s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(270 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.2s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(288 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.15s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(306 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.1s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(324 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.05s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(342 50 50)">
          <rect
            x="48"
            y="29.5"
            rx="9.6"
            ry="5.9"
            width="4"
            height="1"
            fill="#3763e6"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
      </svg>
    </SpinnerContainer>
  );
};
